async function shareUrl() {
    const shareData = {
        title: document.querySelector('meta[property="og:title"]').content,
        url: window.location.href,
    }

    try {
        await navigator.share(shareData)
    } catch (err) {
        if (err && err.name === 'AbortError') {
            return
        }

        try {
            // copy url to clipboard if share is not supported
            await navigator.clipboard.writeText(shareData.url)

            Eshop.alert($(this).data('success'))
        } catch (err) {
            Eshop.alert(
                $(this).data('error'),
                { type: 'error' }
            )
        }
    }
}

$(function () {
    $('.js-blog-gallery').lightGallery(
        $.extend({}, lightGallerySettings, {
            selector: '.js-lightbox',
            galleryId: 1
        })
    );

    $('.js-blog-gallery').on('onBeforeOpen.lg', function() {
        freezeScroll();
    });

    $('.js-blog-gallery').on('onCloseAfter.lg', function() {
        unfreezeScroll();
    });

    $('.l-articles')
        .on('click', '.js-articles-menu', function () {
            var $nav = $('.js-articles-nav');

            $nav.slideToggle(250);
        });

    $('body').on('click', '.pager__item a', function () {
        $('.l-articles__content').slideHere(60);
    });

    $('.js-share-current-url').on('click', shareUrl);

    $('.js-lightbox-holder').each(function() {
        $(this).lightGallery({
            iframeMaxWidth: '100%',
            width: '100%',
            download: false,
            zoom: false,
            getCaptionFromTitleOrAlt: false,
            addClass: 'ifr',
            selector: '.js-lightbox',
        });
    });
});
